// Daily-report recipients tab (admin).
// Part of the Reference page (components/Reference.jsx). Split out 2026-10-14.
import { useState, useEffect } from 'react';
import { useApi, putJson } from '../../api.js';

// ============================================================================
//  DailyMailPanel -- admin picks who receives the daily ops report PDF
//  when it's saved. kv_store('daily-report-recipients','primary').
// ============================================================================
export default function DailyMailPanel() {
  // Data: who receives the Daily Ops Report PDF (one email per line).
  const { data, loading, error, refresh } = useApi('/api/daily-report/recipients');
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    if (data && Array.isArray(data.emails)) {
      setText(data.emails.join('\n'));
    }
  }, [data]);

  // Save the list.
  async function save() {
    setSaving(true); setMsg(null);
    try {
      const emails = text.split(/[\n,;]/).map(s => s.trim()).filter(Boolean);
      await putJson('/api/daily-report/recipients', { emails });
      setMsg({ kind: 'ok', text: 'Saved ' + emails.length + ' recipient(s).' });
      refresh();
    } catch (e) { setMsg({ kind: 'error', text: e.message || String(e) }); }
    finally { setSaving(false); }
  }

  if (loading && !data) return <div className="loading">Loading recipients...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  // Screen: textarea of addresses + Save.
  return (
    <div style={{ maxWidth: 520 }}>
      <p className="small" style={{ color: '#64748b' }}>
        Every save of the Daily Ops Report emails the PDF to these addresses. One per line
        (commas and semicolons also accepted). Blank list = no email sent.
      </p>
      <textarea value={text} onChange={e => setText(e.target.value)}
                rows={8}
                placeholder={'ops@ecovac.ca\nfinance@ecovac.ca'}
                style={{ width: '100%', fontFamily: 'monospace', fontSize: '0.9em',
                         padding: '0.5rem', border: '1px solid #cbd5e1', borderRadius: 4 }} />
      {msg && (
        <div className="small" style={{ padding: '0.35rem 0.5rem', borderRadius: 4, marginTop: '0.5rem',
                                        background: msg.kind === 'ok' ? '#dcfce7' : '#fee2e2',
                                        color:      msg.kind === 'ok' ? '#166534' : '#991b1b' }}>
          {msg.text}
        </div>
      )}
      <div style={{ marginTop: '0.75rem' }}>
        <button className="refresh-btn" onClick={save} disabled={saving} style={{ background: '#0369a1' }}>
          {saving ? 'Saving...' : 'Save recipients'}
        </button>
        {data && data.updated_at && (
          <span className="small" style={{ marginLeft: '0.75rem', color: '#64748b' }}>
            Last updated {String(data.updated_at).slice(0, 19).replace('T', ' ')} by {data.updated_by || '?'}
          </span>
        )}
      </div>
    </div>
  );
}
